import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from './AuthContext';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  // Backend redirects here with ?status=success or ?status=error
  const resultStatus = searchParams.get('status');
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (resultStatus === 'success') {
      // Verification already done by backend — refresh auth state and signal other tabs
      localStorage.setItem('emailVerified', Date.now().toString());
      refreshUser();
    }
  }, [resultStatus, refreshUser]);

  const status = resultStatus === 'success' ? 'success' : resultStatus === 'error' ? 'error' : 'loading';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex justify-center">
          <h1 className="text-4xl font-bold text-indigo-600">💝 Gifted</h1>
        </Link>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-10 px-4 shadow sm:rounded-lg sm:px-10 text-center space-y-4">
          {status === 'loading' && (
            <>
              <div className="text-4xl animate-pulse">📧</div>
              <p className="text-gray-600">Verifying your email…</p>
            </>
          )}
          {status === 'success' && (
            <>
              <div className="text-4xl">✅</div>
              <h2 className="text-xl font-bold text-gray-900">Email verified!</h2>
              <p className="text-gray-500 text-sm">Your account is now fully active.</p>
              <Link
                to="/"
                className="inline-block mt-2 px-5 py-2 bg-indigo-500 text-white text-sm font-medium rounded-lg hover:bg-indigo-600"
              >
                Go to feed
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="text-4xl">❌</div>
              <h2 className="text-xl font-bold text-gray-900">Link invalid or expired</h2>
              <p className="text-gray-500 text-sm">
                This verification link has already been used or has expired.
              </p>
              <Link
                to="/"
                className="inline-block mt-2 text-indigo-600 hover:text-indigo-600 text-sm font-medium"
              >
                Back to home
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
